import { useQuery } from '@tanstack/react-query';
import type { components } from '@/api/schema';

export type GlobalCategory = components['schemas']['GlobalCategoryResource'];

/**
 * FR-98: product categories are the platform's global categories — active
 * only, sorted by name, the same in forms, filters and POS chips (as Lovable).
 */
export function useCategories() {
  return useQuery({
    queryKey: ['/global-categories'],
    select: (res: { data?: GlobalCategory[] }) =>
      (res?.data ?? [])
        .filter((c) => c.status === 'active')
        .sort((a, b) => String(a.name).localeCompare(String(b.name), 'uz')),
  });
}
